export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/Payment.af0667f1.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};